/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommissionAdminReportDto } from '../models';
// @ts-ignore
import type { CommissionPaymentStatusDto } from '../models';
// @ts-ignore
import type { UpdateCommissionPaymentStatusesRequestDto } from '../models';
/**
 * RestCommissionAdministrationApi - axios parameter creator
 */
export const RestCommissionAdministrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all commission data for administration
         * @param {string} [recipientId] 
         * @param {number} [supervisorId] 
         * @param {string} [month] 
         * @param {string} [processId] 
         * @param {number} [offerId] 
         * @param {CommissionPaymentStatusDto} [paymentStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCommissionReport: async (recipientId?: string, supervisorId?: number, month?: string, processId?: string, offerId?: number, paymentStatus?: CommissionPaymentStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/commissions/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recipientId !== undefined) {
                localVarQueryParameter['recipientId'] = recipientId;
            }

            if (supervisorId !== undefined) {
                localVarQueryParameter['supervisorId'] = supervisorId;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (processId !== undefined) {
                localVarQueryParameter['processId'] = processId;
            }

            if (offerId !== undefined) {
                localVarQueryParameter['offerId'] = offerId;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update one or more complete commission payment statuses
         * @param {UpdateCommissionPaymentStatusesRequestDto} updateCommissionPaymentStatusesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionPaymentStatuses: async (updateCommissionPaymentStatusesRequestDto: UpdateCommissionPaymentStatusesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCommissionPaymentStatusesRequestDto' is not null or undefined
            assertParamExists('updateCommissionPaymentStatuses', 'updateCommissionPaymentStatusesRequestDto', updateCommissionPaymentStatusesRequestDto)
            const localVarPath = `/api/commissions/admin/payment-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommissionPaymentStatusesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCommissionAdministrationApi - functional programming interface
 */
export const RestCommissionAdministrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCommissionAdministrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all commission data for administration
         * @param {string} [recipientId] 
         * @param {number} [supervisorId] 
         * @param {string} [month] 
         * @param {string} [processId] 
         * @param {number} [offerId] 
         * @param {CommissionPaymentStatusDto} [paymentStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCommissionReport(recipientId?: string, supervisorId?: number, month?: string, processId?: string, offerId?: number, paymentStatus?: CommissionPaymentStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionAdminReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCommissionReport(recipientId, supervisorId, month, processId, offerId, paymentStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCommissionAdministrationApi.getAdminCommissionReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update one or more complete commission payment statuses
         * @param {UpdateCommissionPaymentStatusesRequestDto} updateCommissionPaymentStatusesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto: UpdateCommissionPaymentStatusesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCommissionAdministrationApi.updateCommissionPaymentStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCommissionAdministrationApi - factory interface
 */
export const RestCommissionAdministrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCommissionAdministrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all commission data for administration
         * @param {string} [recipientId] 
         * @param {number} [supervisorId] 
         * @param {string} [month] 
         * @param {string} [processId] 
         * @param {number} [offerId] 
         * @param {CommissionPaymentStatusDto} [paymentStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCommissionReport(recipientId?: string, supervisorId?: number, month?: string, processId?: string, offerId?: number, paymentStatus?: CommissionPaymentStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<CommissionAdminReportDto> {
            return localVarFp.getAdminCommissionReport(recipientId, supervisorId, month, processId, offerId, paymentStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update one or more complete commission payment statuses
         * @param {UpdateCommissionPaymentStatusesRequestDto} updateCommissionPaymentStatusesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto: UpdateCommissionPaymentStatusesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCommissionAdministrationApi - interface
 */
export interface RestCommissionAdministrationApiInterface {
    /**
     * 
     * @summary Get all commission data for administration
     * @param {string} [recipientId] 
     * @param {number} [supervisorId] 
     * @param {string} [month] 
     * @param {string} [processId] 
     * @param {number} [offerId] 
     * @param {CommissionPaymentStatusDto} [paymentStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminCommissionReport(recipientId?: string, supervisorId?: number, month?: string, processId?: string, offerId?: number, paymentStatus?: CommissionPaymentStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<CommissionAdminReportDto>;

    /**
     * 
     * @summary Update one or more complete commission payment statuses
     * @param {UpdateCommissionPaymentStatusesRequestDto} updateCommissionPaymentStatusesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto: UpdateCommissionPaymentStatusesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestCommissionAdministrationApi - object-oriented interface
 */
export class RestCommissionAdministrationApi extends BaseAPI implements RestCommissionAdministrationApiInterface {
    /**
     * 
     * @summary Get all commission data for administration
     * @param {string} [recipientId] 
     * @param {number} [supervisorId] 
     * @param {string} [month] 
     * @param {string} [processId] 
     * @param {number} [offerId] 
     * @param {CommissionPaymentStatusDto} [paymentStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdminCommissionReport(recipientId?: string, supervisorId?: number, month?: string, processId?: string, offerId?: number, paymentStatus?: CommissionPaymentStatusDto, options?: RawAxiosRequestConfig) {
        return RestCommissionAdministrationApiFp(this.configuration).getAdminCommissionReport(recipientId, supervisorId, month, processId, offerId, paymentStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update one or more complete commission payment statuses
     * @param {UpdateCommissionPaymentStatusesRequestDto} updateCommissionPaymentStatusesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto: UpdateCommissionPaymentStatusesRequestDto, options?: RawAxiosRequestConfig) {
        return RestCommissionAdministrationApiFp(this.configuration).updateCommissionPaymentStatuses(updateCommissionPaymentStatusesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

